import React from 'react';
import classnames from 'classnames';
import { Box } from '@fiverr-private/theme';
import { translate } from '@fiverr-private/i18n-react';
import { Skeleton, SkeletonSquare } from '@fiverr-private/feedback';
import { Container } from '@fiverr-private/layout_components';
import { getContext } from '@fiverr-private/fiverr_context';
import { replaceUnderScoreWithHyphen } from '../../utils/replaceUnderScoreWithHyphen';
import { ErrorState } from '../shared/ErrorState/ErrorState';
import { HEADER_HEIGHT } from '../gigs/DynamicGigCardCarouselWrapper/constants';
import { PersonalizedComponentMapper } from '../PersonalizedComponentMapper/ComponentMapper.lazy';
import { showMoreLinkStyles } from './TabsView.styles.ve.css';
import { getCarouselHeight, getExcludedBadges } from './utils';
import { TabCarouselPanelProps } from './types';

const TabCarouselPanel = (props: TabCarouselPanelProps) => {
    const { component, isLoading, isErrorState } = props;
    const personalizedClass = replaceUnderScoreWithHyphen(component?.type ?? '');
    const excludedBadges = getExcludedBadges(component);
    const { isMobile } = getContext();

    if (isErrorState && !component?.items?.gigs && !component?.items?.sellerRoles) {
        const translationPrefix = 'personalized_content.error_state';

        return (
            <ErrorState
                title={translate(`${translationPrefix}.title`) satisfies string}
                subtitle={translate(`${translationPrefix}.subtitle`) satisfies string}
            />
        );
    }

    const carouselHeight = getCarouselHeight(component);

    return isLoading ? (
        <Skeleton width="auto">
            <Box height={`${HEADER_HEIGHT}px`} width="100%" />
            <SkeletonSquare width="100%" height={carouselHeight} />
        </Skeleton>
    ) : (
        <Container
            className={classnames(
                'recommendations-carousel',
                { 'recommendations-carousel-mobile': isMobile },
                personalizedClass
            )}
            minHeight={`${carouselHeight}px`}
        >
            <PersonalizedComponentMapper
                {...props}
                sectionName={''}
                component={component}
                withCarouselHeaderText={false}
                withFooter={false}
                showMoreClassName={showMoreLinkStyles}
                excludedBadges={excludedBadges}
            />
        </Container>
    );
};

export default TabCarouselPanel;
